<template>
  <router-view />
</template>

<script>
export default {
  name: 'UserWrapper',
  data: () => ({
    page: {
      title: 'Usuario',
      icon: 'fas fa-user-cog',
      routes: ['Usuario'],
    },
  }),
  provide() {
    return {
      page: this.page,
    };
  },
};
</script>
